import { globalEntitlements } from '../utils/globalEntitlements';

export const WFC_ADVANCED_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.wfcAdvanced.buyBox.bulletPoint1' },
          { title: 'productPage.wfcAdvanced.buyBox.bulletPoint2' },
          { title: 'productPage.wfcAdvanced.buyBox.bulletPoint3' },
          { title: 'productPage.wfcAdvanced.buyBox.bulletPoint4' },
        ],
        productName: 'productPage.wfcAdvanced.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.wfcAdvanced.buyBox.veloCta.prompt',
          topic: 'wfc-advanced-addon',
        },
        interactService: {
          service: 'worry_free_service_advanced_addon',
          ctaType: 'internalCheckout',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/woodworker-finishing-chair.png',
      alt: 'productPage.wfcAdvanced.heroPicture.altText',
    },
    comparePackages: 'productPage.wfcAdvanced.buyBox.comparePackages',
    plans: {
      title: 'productPage.wfcAdvanced.compareModal.title',
      items: [
        {
          name: 'productPage.wfcAdvanced.optionLabel.option1',
          features: [
            'productPage.wfcAdvanced.comparePackages.features.option1',
            'productPage.wfcAdvanced.comparePackages.features.option2',
            'productPage.wfcAdvanced.comparePackages.features.option3',
            'productPage.wfcAdvanced.comparePackages.features.option4',
            'productPage.wfcAdvanced.comparePackages.features.option5',
            'productPage.wfcAdvanced.comparePackages.features.option6',
            'productPage.wfcAdvanced.comparePackages.features.option7',
          ],
          disabledFeatures: [
            'productPage.wfcAdvanced.comparePackages.features.option9',
            'productPage.wfcAdvanced.comparePackages.features.option10',
          ],
          tag: {
            label: 'productPage.wfcAdvanced.optionLabel.option1Callout',
            color: 'default',
          },
          icon: {
            src: '/s2/material-icons/gppgoodrounded.svg',
            color: 'text.green',
            bgColor: 'green',
          },
        },
        {
          name: 'productPage.wfcAdvanced.optionLabel.option2',
          features: [
            'productPage.wfcAdvanced.comparePackages.features.option1',
            'productPage.wfcAdvanced.comparePackages.features.option2',
            'productPage.wfcAdvanced.comparePackages.features.option3',
            'productPage.wfcAdvanced.comparePackages.features.option4',
            'productPage.wfcAdvanced.comparePackages.features.option5',
            'productPage.wfcAdvanced.comparePackages.features.option6',
            'productPage.wfcAdvanced.comparePackages.features.option8',
            'productPage.wfcAdvanced.comparePackages.features.option9',
            'productPage.wfcAdvanced.comparePackages.features.option10',
          ],
          tag: {
            label: 'productPage.wfcAdvanced.optionLabel.option2Callout',
            color: 'palette.background.cyan.main',
          },
          icon: {
            src: '/s2/material-icons/workspacepremiumrounded.svg',
            color: 'text.blue',
            bgColor: 'cyan',
          },
        },
      ],
    },
    headline: 'productPage.wfcAdvanced.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {},
    subheader: 'productPage.wfcAdvanced.page.subheader',
  },
  benefit: {
    title: 'productPage.wfcAdvanced.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.wfcAdvanced.valueProp.propTitle1',
        description: 'productPage.wfcAdvanced.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/diamondrounded.svg',
        title: 'productPage.wfcAdvanced.valueProp.propTitle2',
        description: 'productPage.wfcAdvanced.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/allinclusiverounded.svg',
        title: 'productPage.wfcAdvanced.valueProp.propTitle3',
        description: 'productPage.wfcAdvanced.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/filedownloaddonerounded.svg',
    title: 'productPage.wfcAdvanced.topFeature.title',
    subheader: 'productPage.wfcAdvanced.topFeature.subheader',
    image: '/s2/raster/bike-repair-woman-workshop.png',
    alt: 'productPage.wfcAdvanced.topFeature.altText',
  },
  whatsIncluded: {
    title: 'productPage.wfcAdvanced.whatsIncluded.title',
    items: [
      {
        title: 'productPage.wfcAdvanced.whatsIncluded.item1',
        description: 'productPage.wfcAdvanced.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.wfcAdvanced.whatsIncluded.item2',
        description: 'productPage.wfcAdvanced.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.wfcAdvanced.whatsIncluded.item3',
        description: 'productPage.wfcAdvanced.whatsIncluded.item3ShortDescription',
      },
      {
        title: 'productPage.wfcAdvanced.whatsIncluded.item4',
        description: 'productPage.wfcAdvanced.whatsIncluded.item4ShortDescription',
      },
    ],
    image: '/s2/raster/cafe-owner-using-tablet.png',
    alt: 'productPage.wfcAdvanced.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false,
  },
  howItWorks: {
    title: 'productPage.wfcAdvanced.howItWorks.title',
    items: [
      {
        title: 'productPage.wfcAdvanced.howItWorks.step1',
        description: 'productPage.wfcAdvanced.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.wfcAdvanced.howItWorks.step2',
        description: 'productPage.wfcAdvanced.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.wfcAdvanced.howItWorks.step3',
        description: 'productPage.wfcAdvanced.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/good-standing-certificate-claim.png',
    alt: 'productPage.wfcAdvanced.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.wfcAdvanced.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.wfcAdvanced.frequentlyAskedQuestions.faq1',
        answer: 'productPage.wfcAdvanced.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.wfcAdvanced.frequentlyAskedQuestions.faq2',
        answer: 'productPage.wfcAdvanced.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.wfcAdvanced.frequentlyAskedQuestions.faq3',
        answer: 'productPage.wfcAdvanced.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.wfcAdvanced.needAssistance.title',
    getInTouch: 'productPage.wfcAdvanced.needAssistance.getInTouch',
    actions: 'productPage.wfcAdvanced.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.wfcAdvanced.buyBox.buttonLabel',
    ctaDisabledTooltip: 'productPage.common.buyBox.buttonDisabled.tooltip',
  })
    .blockedByRelatedServices(['worry_free_service_advanced', 'worry_free_service_advanced_addon'])
    .requiresProduct(
      'worry_free_service',
      'productPage.wfcAdvanced.buyBox.buttonDisabledNotAvailable.tooltip',
      'productPage.wfcAdvanced.buyBox.buttonLabelNotAvailable',
    )
    .build(),
};
